import { LinearProgress } from "@mui/material";
import { FC } from "react";

import { ICoursesCalendarRideProduceProgressProps } from "./courses-calendar-ride-produce.models";

export const CoursesCalendarRideProduceProgress: FC<
  ICoursesCalendarRideProduceProgressProps
> = ({ show, value }) => {
  if (!show) {
    return null;
  }

  return (
    <LinearProgress
      variant="determinate"
      value={value}
      className="cc-ride-produce-progress"
    />
  );
};
